/**
 * Break-glass: the pickup / transit / delivery columns of the review summary.
 *
 * They sit side by side until the review frame measures itself narrow and
 * publishes `.quote-card-narrow`, at which point they stack. That switch is
 * driven by a class an ancestor sets from a runtime measurement, so only a
 * Tailwind `in-[...]` variant can read it — no primitive takes "lay out
 * differently when some ancestor says so".
 */

import type { ReactNode } from "react";

interface BookShipmentReviewSummaryColumnsProps {
  children: ReactNode;
}

export function BookShipmentReviewSummaryColumns({
  children,
}: BookShipmentReviewSummaryColumnsProps) {
  return (
    <div className="flex w-full flex-row items-start in-[.quote-card-narrow]:flex-col in-[.quote-card-narrow]:gap-8">
      {children}
    </div>
  );
}
